import React from "react";
import {
  FormFields,
  useRegistration,
} from "../../../contexts/RegistrationContext";
import RegistrationBox from "../RegistrationBox";
import { OrangeRegistrationInput } from "../Inputs";
import { Alert, Col, Form, Row } from "antd";

const LoginDetails = ({ missingFields }) => {
  const { formData } = useRegistration();

  const isPasswordsDifferent =
    formData[FormFields.ACCOUNT_INFO.PASSWORD] !==
      formData[FormFields.ACCOUNT_INFO.PASSWORD_AGAIN] &&
    formData[FormFields.ACCOUNT_INFO.PASSWORD_AGAIN] !== "";

  const inputs = [
    FormFields.ACCOUNT_INFO.PASSWORD,
    FormFields.ACCOUNT_INFO.PASSWORD_AGAIN,
  ];

  return (
    <RegistrationBox
      title="פרטי התחברות"
      className="agent-reg-stage-card"
      lead="סיסמה חזקה שומרת על החשבון ועל הלקוחות שלכם."
    >
      <Form layout="vertical" className="agent-reg-fields-form">
        <Row gutter={[14, 2]} className="agent-reg-fields-grid">
          {inputs.map((key) => (
            <Col xs={24} sm={12} key={key}>
              <OrangeRegistrationInput
                registrationKey={key}
                type="password"
                missingFields={missingFields}
              />
            </Col>
          ))}
        </Row>
      </Form>
      {isPasswordsDifferent && (
        <Alert
          message="הסיסמאות חייבות להיות זהות"
          type="error"
          showIcon
          className="agent-reg-inline-alert"
        />
      )}
    </RegistrationBox>
  );
};

export default LoginDetails;
